module.exports = __webpack_public_path__ + "img/icon-filter.4f75b6cb.svg";